// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkIn-modal .modal-container {
  width: 480px !important;
  height: auto !important;
}
.checkIn-modal .modal-header {
  padding-bottom: 0 !important;
  border-bottom: none !important;
}

.checkIn-modal2 .modal-container {
  width: 480px !important;
  height: 528px !important;
}
.checkIn-modal2 .modal-header {
  padding-bottom: 0 !important;
  border-bottom: none !important;
}

.checkIn-bg {
  border-radius: 8px;
  background: var(--White, #FDFDFD);
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.2);
}

.loading-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  background-color: #009D64;
  animation: decrease-width 3s linear forwards;
  width: 100%;
}

.attendee-detail {
  width: 100% !important;
}
.attendee-detail .accordion-title {
  font-size: 16px !important;
  padding: 0 !important;
}
.attendee-detail .accordion-content {
  padding: 0 !important;
  padding-top: 8px !important;
}

.attendee-detail2 {
  width: 100% !important;
}
.attendee-detail2 .accordion-title {
  font-size: 16px !important;
  padding: 0 !important;
  color: #009D64 !important;
  font-weight: 600 !important;
}
.attendee-detail2 .accordion-content {
  padding: 0 !important;
  padding-top: 8px !important;
}

.attendee-label .label-wrapper {
  width: 100% !important;
}

.attendee-label .label-wrapper .label {
  font-size: 16px !important;
}

.outer-ring {
  position: relative;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  border: 1px solid #B7B7B7;
  background-color: #FFFFFF;
}
.outer-ring .inner-ring {
  position: absolute;
  inset: 3px;
  width: 12px;
  height: 12px;
  background-color: #009D64;
  border-radius: 50%;
}

@keyframes decrease-width {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/event-dashboard/containers/attendees/style.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,4BAAA;EACA,8BAAA;AADJ;;AAME;EACE,uBAAA;EACA,wBAAA;AAHJ;AAME;EACE,4BAAA;EACA,8BAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,iCAAA;EACA,+CAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,4CAAA;EACA,WAAA;AALF;;AAQA;EACE,sBAAA;AALF;AAOE;EACE,0BAAA;EACA,qBAAA;AALJ;AAQE;EACE,qBAAA;EACA,2BAAA;AANJ;;AAWA;EACE,sBAAA;AARF;AAUE;EACE,0BAAA;EACA,qBAAA;EACA,yBAAA;EACA,2BAAA;AARJ;AAWE;EACE,qBAAA;EACA,2BAAA;AATJ;;AAaA;EACE,sBAAA;AAVF;;AAcA;EACE,0BAAA;AAXF;;AAcA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;AAXJ;AAaI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAXN;;AAeA;EACE;IACE,WAAA;EAZF;EAcA;IACE,SAAA;EAZF;AACF","sourcesContent":[".checkIn-modal{\n  .modal-container{\n    width: 480px !important;\n    height: auto !important;\n  }\n\n  .modal-header{\n    padding-bottom: 0 !important;\n    border-bottom: none !important;\n  }\n}\n\n.checkIn-modal2{\n  .modal-container{\n    width: 480px !important;\n    height: 528px !important;\n  }\n\n  .modal-header{\n    padding-bottom: 0 !important;\n    border-bottom: none !important;\n  }\n}\n\n.checkIn-bg{\n  border-radius: 8px;\n  background: var(--White, #FDFDFD);\n  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.20); \n}\n\n.loading-bar{\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 4px;\n  background-color:#009D64;\n  animation: decrease-width 3s linear forwards;\n  width: 100%;\n}\n\n.attendee-detail{\n  width: 100% !important;\n\n  .accordion-title{\n    font-size: 16px !important;\n    padding: 0 !important;\n  }\n\n  .accordion-content{\n    padding: 0 !important;\n    padding-top: 8px !important;\n  }\n}\n\n\n.attendee-detail2{\n  width: 100% !important;\n\n  .accordion-title{\n    font-size: 16px !important;\n    padding: 0 !important;\n    color: #009D64 !important;\n    font-weight: 600 !important;\n  }\n\n  .accordion-content{\n    padding: 0 !important;\n    padding-top: 8px !important;\n  }\n}\n\n.attendee-label .label-wrapper{\n  width: 100% !important;\n\n}\n\n.attendee-label .label-wrapper .label{\n  font-size: 16px !important;\n}\n\n.outer-ring {\n    position: relative;\n    border-radius: 50%;\n    height: 20px;\n    width: 20px;\n    border: 1px solid theme('colors.grey-50');\n    background-color: theme('colors.full-white');\n\n    .inner-ring {\n      position: absolute;\n      inset: 3px;\n      width: 12px;\n      height: 12px;\n      background-color: theme('colors.primary-green');\n      border-radius: 50%;\n    }\n  }\n\n@keyframes decrease-width {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
